export default __webpack_public_path__ + "static/media/stomach.f6268b12.svg";